<template>
  <div class="cellBar">
    <h3 class="title">{{title}}</h3>
  </div>
</template>

<script>
export default {
  name: "cellBar",
  props: {
    title: {
      type: String
    }
  }
};
</script>

<style scoped lang="less">
.cellBar {
  padding: 20px;
  .title {
    border-left: 3px solid #0065FF;
    padding-left: 8px;
    font-size: 16px;
    color: #333;
    font-weight: 600;
    line-height: 100%;
  }
}
</style>
